import React from "react";
import { STATUS_FILTERS } from "../../constants";
import { SessionStatus } from "../../types/models";
import "./WebinarFilters.scss";

type Props = {
  status: "all" | SessionStatus;
  q: string;
  counts: Record<"all" | SessionStatus, number>;
  onStatusChange: (status: "all" | SessionStatus) => void;
  onQueryChange: (q: string) => void;
};

const WebinarFilters: React.FC<Props> = ({
  status,
  q,
  counts,
  onStatusChange,
  onQueryChange,
}) => {
  return (
    <div className="wf-filters">
      <div className="wf-filters__tabs" role="tablist" aria-label="Session status">
        {STATUS_FILTERS.map((tab) => {
          const active = status === tab.key;
          return (
            <button
              key={tab.key}
              type="button"
              role="tab"
              aria-selected={active}
              className={`wf-filters__tab${active ? " is-active" : ""}`}
              onClick={() => onStatusChange(tab.key)}
            >
              <span>{tab.label}</span>
              <span className="wf-filters__count">{counts[tab.key]}</span>
            </button>
          );
        })}
      </div>
      <label className="wf-filters__search">
        <span className="wf-sr-only">Search sessions</span>
        <input
          type="search"
          value={q}
          placeholder="Search title, host, topic…"
          onChange={(e) => onQueryChange(e.target.value)}
        />
      </label>
    </div>
  );
};

export default WebinarFilters;
